module.exports = __webpack_public_path__ + "images/01e85df3c9572f4441b51bcffab46ac7-swappanelxt.png";